import type { Feeling } from '@fyf/shared';
import { BRAND_COPY, FEELINGS } from '@fyf/shared';

import { OptionGrid } from '../components/OptionGrid.js';
import { ScreenLayout } from '../components/ScreenLayout.js';
import { StepIndicator } from '../components/StepIndicator.js';
import { SubmitButton } from '../components/SubmitButton.js';
import { useCaptureDispatch, useCaptureState } from '../context/CaptureFlowContext.js';

const { feeling: copy } = BRAND_COPY.screens;

export function FeelingScreen() {
  const { feeling } = useCaptureState();
  const dispatch = useCaptureDispatch();

  function handleSelect(value: Feeling) {
    dispatch({ type: 'SET_FEELING', payload: value });
  }

  function handleNext() {
    if (feeling) {
      dispatch({ type: 'SET_SCREEN', payload: 'spark' });
    }
  }

  return (
    <ScreenLayout>
      <StepIndicator label={copy.stepLabel} currentStep={2} />
      <h2 className="text-[32px] font-['Lora',serif] text-center mb-6">
        How do you want to
        <br />
        <span className="text-brand-gradient italic">feel</span> at work?
      </h2>
      <p className="font-['DM_Sans',sans-serif] text-base text-white text-center mb-10">
        {copy.hint}
      </p>
      <OptionGrid
        options={FEELINGS}
        selected={feeling}
        onSelect={handleSelect}
        label={copy.question}
      />
      <div className="mt-10 w-full max-w-md">
        <SubmitButton label={copy.button} onClick={handleNext} disabled={!feeling} />
      </div>
    </ScreenLayout>
  );
}
